import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter
} from "./ui/dialog";

export default function ChapterActionDateDialog({ value, onChange, onConfirm, onClose }) {
  const isStart = value?.action === "start";
  return (
    <Dialog open={!!value} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">
            {isStart ? "Démarrer le chapitre" : "Terminer le chapitre"}
          </DialogTitle>
        </DialogHeader>
        {value && (
          <div className="space-y-2">
            <label className="eyebrow block">
              {isStart ? "Date de début du chapitre" : "Date de fin du chapitre"}
            </label>
            <input
              type="date"
              value={value.date}
              onChange={(e) => onChange({ ...value, date: e.target.value })}
              className="w-full px-4 py-3 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none font-mono-spec"
              data-testid="chapter-date-input"
            />
            <p className="text-xs text-[var(--ink-soft)]">Une fois enregistrée, cette date ne pourra être modifiée que par la direction.</p>
          </div>
        )}
        <DialogFooter>
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn-primary" onClick={onConfirm} data-testid="chapter-date-confirm-btn">
            {isStart ? "Démarrer" : "Terminer"}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
